module.exports = __webpack_public_path__ + "media/site_templates/www.tv-installation.com.au/images/our_services_3-0d0634b2906e380eab743dda90fdca04.jpg";